import type { MonitorAndProtectModelCompetitorsResponsePeriod } from "@similarweb/pro-api-client";

import { ChartConfigBuilder } from "app/pages/digital-marketing/common/services/charts/ChartConfigBuilder";
import { DateFormatter } from "app/pages/digital-marketing/common/services/formatters/dateFormatter";

import { NumberFormatter } from "../../../services/number-formatter";

import type { GranularityType, ValueType } from "./types";

export const getYAxisFormatter = (valueType: ValueType) =>
    valueType === "absolute"
        ? (value: number) => NumberFormatter.toAbbr(value, 1)
        : (value: number) => NumberFormatter.toSmartPercent(value / 100);

export const getXAxisFormatter = (granularity: GranularityType) => {
    switch (granularity) {
        case "Day":
            return (value: string | number) => DateFormatter.toShortMonthDay(value);
        case "Week":
            return (value: string | number) => DateFormatter.toShortMonthDay(value);
        default:
            return (value: string | number) => DateFormatter.toShortMonthDay(value);
    }
};

export const getLegendHeaders = (translate?: (key: string) => string): [string, string] => {
    if (translate) {
        return [
            translate("monitor_and_protect.competitors.chart.legend.domain"),
            translate("monitor_and_protect.competitors.chart.legend.total_clicks"),
        ];
    }
    return ["Domain", "Total Clicks"];
};

export const competitorsChartConfigBuilder = new ChartConfigBuilder<
    "area",
    object,
    { absolute: number; relative: number; period: MonitorAndProtectModelCompetitorsResponsePeriod }
>().withStyle({
    marginRight: 24,
});
